import { Header } from './Header';
import { MessageSquare } from 'lucide-react';

export function ChatbotPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-7xl mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-20 w-full">
        <div className="grid grid-cols-12 gap-x-6">
          <div className="col-span-12 lg:col-span-10">
            <p className="eyebrow text-primary mb-6">Compass</p>
            <h1 className="display-lg text-white mb-6">
              The PMO consultant<br />on the other side of a chat.
            </h1>
            <p className="text-lg text-white/65 max-w-2xl leading-snug">
              Compass is Movar Reply's AI assistant. It answers questions about our services,
              produces visualisations on demand, and can scope out an engagement before any
              meeting is booked.
            </p>
            <p className="mt-12 text-sm text-white/45 max-w-2xl leading-relaxed flex items-center gap-3">
              <MessageSquare className="w-4 h-4 text-primary" />
              Click <span className="font-medium text-white/75">Talk to Compass</span> on the
              home page to start a conversation.
            </p>
          </div>
        </div>
      </main>

      <footer className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
          <p className="eyebrow text-white/40">&copy; 2026 Movar Reply</p>
          <p className="text-sm text-white/45 italic">big enough to deliver, small enough to care</p>
          <p className="eyebrow text-white/30 md:ml-auto">A Reply Group company</p>
        </div>
      </footer>
    </div>
  );
}
